export default __webpack_public_path__ + "static/media/nav-archive.54d3cbe8.svg";